import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import TiptapEditor from "@/components/TiptapEditor";
import { knowledgeApi } from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2, Lock } from "lucide-react";

export function ArticleFormDialog({
  open,
  onOpenChange,
  editArticle,
  formTitle,
  setFormTitle,
  formCategory,
  setFormCategory,
  formContent,
  setFormContent,
  formTags,
  setFormTags,
  formVisibility,
  setFormVisibility,
  categories,
  parentOptions = [],
  formParentId = "",
  setFormParentId,
  onSubmit,
  saving,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>{editArticle ? "Artikel bearbeiten" : "Neuer Artikel"}</DialogTitle>
          <DialogDescription className="sr-only">
            {editArticle ? "Bearbeiten Sie den Artikel" : "Erstellen Sie einen neuen Artikel"} mit Titel, Kategorie, Inhalt und Tags
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="grid gap-4 py-4">
            <div className="space-y-2">
              <Label>Titel</Label>
              <Input value={formTitle} onChange={(e) => setFormTitle(e.target.value)} required />
            </div>
            <div className="space-y-2">
              <Label>Kategorie</Label>
              <select className="w-full h-10 rounded-md border px-3" value={formCategory} onChange={(e) => setFormCategory(e.target.value)}>
                {categories.map((c) => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div className="space-y-2">
              <Label>Übergeordneter Artikel (optional)</Label>
              <select
                className="w-full h-10 rounded-md border px-3"
                value={formParentId || ""}
                onChange={(e) => setFormParentId && setFormParentId(e.target.value)}
                data-testid="article-parent-select"
              >
                <option value="">— Kein (Hauptartikel) —</option>
                {parentOptions.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
              </select>
            </div>
            <div className="space-y-2">
              <Label>Inhalt</Label>
              <TiptapEditor
                content={formContent}
                onChange={setFormContent}
                placeholder="Artikel-Inhalt eingeben…  (Screenshots per Button, Einfügen oder Ziehen einfügen)"
                onImageUpload={async (file) => {
                  const res = await knowledgeApi.uploadImage(file);
                  const url = res?.data?.url || "";
                  return url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
                }}
              />
            </div>
            <div className="space-y-2">
              <Label>Tags</Label>
              <Input value={formTags} onChange={(e) => setFormTags(e.target.value)} placeholder="Tag1, Tag2" />
            </div>
            <div className="space-y-2">
              <Label className="flex items-center gap-1">
                <Lock className="w-3.5 h-3.5" /> Sichtbarkeit
              </Label>
              <select
                className="w-full h-10 rounded-md border px-3"
                value={formVisibility}
                onChange={(e) => setFormVisibility(e.target.value)}
                data-testid="article-visibility-select"
              >
                <option value="all">Alle Benutzer</option>
                <option value="admins">Nur Administratoren</option>
              </select>
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button type="submit" disabled={saving}>{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Speichern"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
